import { CaretLeftFilled, CaretRightFilled, CheckOutlined, CloseOutlined, MenuFoldOutlined, PauseCircleFilled, PlayCircleFilled, SwapLeftOutlined, SwapRightOutlined } from "@ant-design/icons"
import { Switch } from "antd"
import './ControlPane.css'
type PropsType = {
  screenOrientation: boolean
  switchChange: (checked: boolean) => void
  singleSentencePattern: boolean
  handleVideoPlay: (flag: string) => void
  isVideoPlaying: boolean
  showModal: () => void
  [key: string]: any
}
export default function ControlPane(props: PropsType) {

  return (<div
    className='OperatorPanel_Style'
    style={{
      display: props?.screenOrientation ? 'flex' : 'none',
    }}

  >
    {/* <Slider className='progress' defaultValue={0} onChange={onProgressUpdate} /> */}
    {/* <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            // margin: '.5rem 0'
          }}
        > */}
    <div
      className='videoControlBarLeft_style'
    >
      {/* 单句暂停 */}
      <Switch
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        onChange={props.switchChange}
        size="small"
        defaultChecked={props.singleSentencePattern}
      />
      {/* <Radio.Group onChange={() => { }} defaultValue="0">
            <Radio.Button value="0">0</Radio.Button>
            <Radio.Button value="1">1</Radio.Button>
            <Radio.Button value="∞">∞</Radio.Button>
          </Radio.Group> */}
    </div>
    {/* <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // paddingLeft: '.5rem',
          paddingBottom: '1rem',
          backgroundColor: '#ffffff22',
          borderRadius: '0.5rem',
          width: '2rem',
          height: '2rem'
        }}
        onTouchStart={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onMouseUp={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onTouchEnd={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        onMouseDown={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        ></div> */}
    <div
      className='playButton_Style'

    >


      <SwapLeftOutlined
        style={{ opacity: props.singleSentencePattern ? '1' : '0' }} onClick={props.singleSentencePattern ? () => props.handleVideoPlay('subTitleLeft') : () => { }}
      />
      <CaretLeftFilled
        className='swithsubtitle_Style' onClick={() => props.handleVideoPlay('Left')} />
      {
        props.isVideoPlaying ?
          <PauseCircleFilled
            className='playIcon_Style'

            onClick={() => props.handleVideoPlay('Pause')} /> :
          <PlayCircleFilled
            className='playIcon_Style' onClick={() => props.handleVideoPlay('Play')} />
      }
      <CaretRightFilled className='swithsubtitle_Style'
        onClick={() => props.handleVideoPlay('Right')} />
      <SwapRightOutlined
        style={{ opacity: props.singleSentencePattern ? '1' : '0' }} onClick={props.singleSentencePattern ? () => props.handleVideoPlay('subTitleRight') : () => { }}
      />
    </div>
    {/* <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // paddingLeft: '.5rem',
          paddingBottom: '1rem',
          backgroundColor: '#ffffff22',
          borderRadius: '0.5rem',
          width: '2rem',
          height: '2rem'
        }}
        onTouchStart={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onMouseUp={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('按下')
        }}
        onTouchEnd={(e: React.TouchEvent<HTMLDivElement>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        onMouseDown={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          console?.log('抬起')
        }}
        ></div> */}
    <div
      className='MenuFoldOutlinedWrapper_Style'
    >
      <MenuFoldOutlined onClick={props.showModal} />
    </div>
    {/* </div> */}
  </div>)
}